export const validateAddCustomStopForm = (addressLine: string, stopName: string,  city: string, state: string, zipCode: string, phoneNumber: string): boolean => {
  return addressLine?.length > 0 && stopName?.length > 0 && city?.length > 0 && state?.length > 0 && zipCode?.length > 0 && phoneNumber?.length > 0
}
